const SDK_VERSION = '7.46.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
